import{_ as t}from"./custom-element-CDWT-yC_.js";import{n as e}from"./property-DeTTNf1t.js";function r(r){class o extends r{constructor(){super(...arguments),this.size="m"}}return t([e({reflect:!0})],o.prototype,"size",void 0),o}export{r as S};
//# sourceMappingURL=SizeMixin-DW6qUBEN.js.map
